import { ColorOptions, ModBox, SpacerNew, TextNew } from '@jfs/ui-new'
import { FlatList } from 'react-native'

const ConfigList = ({ configList }: any) => {
  return (
    <ModBox w={'100%'} borderWidth={1} borderRadius={4} borderColor={'#E0E0E0' as ColorOptions} marginTop={16}>
      <ModBox
        backgroundColor={'#F8F8F8' as ColorOptions}
        h={42}
        direction="row"
        alignItems={'center'}
        justifyContent={'flex-start'}
        paddingLeft={16}>
        <TextNew title="Config List" color={'BLACK_21'} fontSize={12} fontFamily="jiotype-bold" />
      </ModBox>
      <FlatList
        nativeID="vertical-scroll"
        data={configList}
        scrollEnabled
        ListEmptyComponent={() => <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />}
        renderItem={({ item }) => (
          <ModBox
            paddingVertical={8}
            paddingHorizontal={16}
            borderTopWidth={1}
            flexDirection={'row'}
            opacity={item?.status?.toLowerCase() === 'active' ? 1 : 0.5}
            borderTopColor={'#E0E0E0' as ColorOptions}>
            <TextNew title={item?.text} color={'BLACK_21'} fontSize={12} fontFamily="jiotype-medium" />
            <SpacerNew direction="horizontal" size={20} />
            <TextNew
              title={item?.status ?? 'INACTIVE'}
              color={STATUS_COLORS[item?.status?.toLowerCase() ?? 'inactive'] ?? 'BLACK_21'}
              fontSize={10}
              fontFamily="jiotype-medium"
            />
          </ModBox>
        )}
        keyExtractor={(item, index) => index}
      />
    </ModBox>
  )
}

const STATUS_COLORS = {
  active: 'AVAILABLE_GREEN',
  inactive: 'TEXT_ERROR',
}

export { ConfigList }
